import { audioService } from '@shared/lib/audio'
import { effectRegistry } from '@shared/lib/effect-registry'
import { setupReactBridge } from '@shared/lib/react-bridge'
import {
  customEffectsPlugin,
  donationAlertPlugin,
  fireworksPlugin,
  textAlertPlugin,
} from '@widgets/effects-layer/plugins'

/**
 * Инициализация приложения.
 * Порядок вызовов важен:
 *
 *  1. setupReactBridge() — React должен быть в globalThis ДО загрузки
 *     любых inline-плагинов с бэкенда.
 *
 *  2. effectRegistry.register() — встроенные плагины со версией "0.0.0".
 *     Любой динамический плагин v"1.0.0"+ перезапишет их.
 *
 *  3. audioService.preload() — звуки грузятся параллельно после регистрации.
 */
export function bootstrap(): void {
  // 1. React в глобальном scope для inline Blob-плагинов
  setupReactBridge()

  // 2. Встроенные плагины (version "0.0.0" — перезаписываемые)
  effectRegistry.register({ ...fireworksPlugin,     version: '0.0.0' })
  effectRegistry.register({ ...textAlertPlugin,     version: '0.0.0' })
  effectRegistry.register({ ...donationAlertPlugin, version: '0.0.0' })
  effectRegistry.register({ ...customEffectsPlugin, version: '0.0.0' })

  // 3. Предзагрузка звуков
  effectRegistry.getAll().forEach((plugin) => {
    if (plugin.sound?.src) void audioService.preload(plugin.sound.src)
  })

  // 4. Попытка разблокировать аудио + навесить слушатели жестов как можно раньше.
  //    В OBS Browser Source autoplay разрешён → контекст стартует сразу.
  //    В обычном браузере звук разблокируется при первом клике/нажатии.
  void audioService.unlock()
}
